import { notification } from 'antd'
import { useQuery } from 'react-query'
import { listMcpTools } from './mcpToolsAdminApi'

const ADMIN_LIST_KEY = ['mcpToolsAdmin', 'list'] as const

/**
 * Load the full MCP tool catalog. It's small and changes only on deploy, so the
 * whole list is fetched once and filtered client-side by the tool pickers.
 */
export const useMcpToolsListQuery = () => {
  return useQuery({
    queryKey: ADMIN_LIST_KEY,
    queryFn: () => listMcpTools(),
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load MCP tools' })
    },
  })
}
